import { useContactType } from "@/api/services/admin/contact-type";
import { FooterActionBar } from "@/components/commons/FooterActionBar";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { ContactTypeForm } from "@/features/contact-type/components/ContactTypeForm";
import { contactMenu } from "@/features/contact-type/constants/contactMenu";
import { convertContactTypeResToForm } from "@/features/contact-type/utils/convert";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { Stack } from "@mui/material";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useParams, useLocation, matchRoutes, useNavigate } from "react-router-dom";

type TContactTypeEditPageProps = {};

export const ContactTypeEditPage: FC<TContactTypeEditPageProps> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef<{ submit: () => void }>(null);
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.contactType, { replace: true });
    }
  }, [id, navigate]);

  const { data: contactTypeResult, isLoading, isError } = useContactType();
  const contactTypeData = contactTypeResult?.data;

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !contactTypeData)) {
      navigate(AppRoutes.contactType, { replace: true });
    }
  }, [id, isLoading, isError, contactTypeData, navigate]);

  const isExtraUrlActive = useMemo(() => {
    return contactMenu.some(({ extraUrls }) => extraUrls?.some((extraUrl) => matchRoutes([{ path: extraUrl }], pathname) !== null));
  }, [pathname]);

  const backUrl = useMemo(() => {
    if (isExtraUrlActive) {
      const activeMenu = contactMenu.find(({ extraUrls }) => extraUrls?.some((extraUrl) => matchRoutes([{ path: extraUrl }], pathname) !== null));
      return activeMenu ? getDynamicRoute(activeMenu.url, { id }) : AppRoutes.duringContractList;
    }
    return AppRoutes.duringContractList;
  }, [isExtraUrlActive, pathname, id]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await Promise.resolve(formRef.current?.submit());
    } finally {
      setLoading(false);
    }
  };

  if (isLoading || !contactTypeData) return <LoadingPage />;
  return (
    <Stack gap={4}>
      <ContactTypeForm previousData={convertContactTypeResToForm(contactTypeData)} ref={formRef} />
      <FooterActionBar title="保存" onSubmit={handleSubmit} isLoading={loading} backUrl={backUrl} />
    </Stack>
  );
};
